import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from '@/hooks/useNotifications';

export default function ChallengeAcceptedHandler() {
  const navigate = useNavigate();

  const handleAccepted = useCallback((data) => {
    if (data?.matchId && data?.gameType) {
      navigate(`/play/${data.gameType.toLowerCase()}/${data.matchId}`);
    }
  }, [navigate]);

  useNotifications({ onChallengeAccepted: handleAccepted });

  return null;
}
